import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FormGroup, ControlLabel, HelpBlock } from "components/bootstrap";
import { Radio } from "components/common";
import { THRESHOLD_MODES } from "license/traffic/types";
const StyledControlLabel = styled(ControlLabel)`
  margin-bottom: ${({ theme }) => theme.spacings.sm};
`;
const RadioOption = styled(Radio)`
  margin-top: 0;
  margin-bottom: 0;
`;
const RadioGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacings.md};
`;
const ThresholdTypeRadioSelector = ({ onChange, selectedThresholdMode }) => {
  const { t } = useTranslation("enterprise_license");
  return /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(StyledControlLabel, null, t("license.traffic.threshold_type")), /* @__PURE__ */ React.createElement(RadioGroup, null, /* @__PURE__ */ React.createElement(
    RadioOption,
    {
      name: "threshold_type",
      checked: selectedThresholdMode === THRESHOLD_MODES.PERCENTAGE,
      onChange: () => onChange(THRESHOLD_MODES.PERCENTAGE)
    },
    /* @__PURE__ */ React.createElement("strong", null, t("license.traffic.percentage_option")),
    /* @__PURE__ */ React.createElement(HelpBlock, null, t("license.traffic.percentage_option_help"))
  ), /* @__PURE__ */ React.createElement(
    RadioOption,
    {
      name: "threshold_type",
      checked: selectedThresholdMode === THRESHOLD_MODES.ABSOLUTE,
      onChange: () => onChange(THRESHOLD_MODES.ABSOLUTE)
    },
    /* @__PURE__ */ React.createElement("strong", null, t("license.traffic.absolute_option")),
    /* @__PURE__ */ React.createElement(HelpBlock, null, t("license.traffic.absolute_option_help"))
  )));
};
export default ThresholdTypeRadioSelector;
